import { useLocation } from "react-router-dom";

/**
 * Returns the base path for driver pages depending on which portal we are in:
 * - admin app: "/drivers"
 * - company portal: "/company/drivers"
 *
 * Lets the same widgets navigate correctly for both contexts.
 */
const useDriversBasePath = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/company") ? "/company/drivers" : "/drivers";
};

export default useDriversBasePath;
